import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { ICON_TEXT_LIST_BASE_CLASSNAME } from './Constants';
import { createIconTextList } from './IconTextList';
createComponents(".".concat(ICON_TEXT_LIST_BASE_CLASSNAME), createIconTextList, NO_PATTERN_BUSINESS_LOGIC);
